import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import loginView from '../views/login/login.vue'
import indexView from '../views/index/index.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'indexView',
    component: indexView
  }, {
    path: '/login',
    name: 'loginView',
    component: loginView
  } 
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
